import { render, staticRenderFns } from "./HowItWorkCompany.vue?vue&type=template&id=0ee21d25&"
import script from "./HowItWorkCompany.vue?vue&type=script&lang=js&"
export * from "./HowItWorkCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports